/* Det Barnemad theme JS */

// Product tabs
document.addEventListener('click', function(e){
  if(e.target.matches('.tab')){
    const filter = e.target.dataset.tab || e.target.dataset.filter;
    const parent = e.target.closest('section');
    parent.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
    e.target.classList.add('active');
    const targetGrid = parent.querySelector('[data-tab-grid]') || parent.querySelector('.product-grid') || parent.querySelector('#grid');
    if(!targetGrid) return;
    targetGrid.querySelectorAll('[data-cat]').forEach(card => {
      if(filter === 'alle' || card.dataset.cat === filter){ card.style.display = ''; }
      else { card.style.display = 'none'; }
    });
  }
});

// FAQ accordion
document.addEventListener('click', function(e){
  const q = e.target.closest('.faq-q');
  if(q){
    q.parentElement.classList.toggle('open');
  }
});

// Newsletter form (Shopify handles submission via theme app extension typically)
document.querySelectorAll('.newsletter-form').forEach(form => {
  form.addEventListener('submit', function(e){
    // Let Shopify Klaviyo / Shopify Email handle this on real site
  });
});
